import _BaseController from 'FF/Controllers/Web/BaseController';
import HeaderController from 'Vue/Web/Header/HeaderController.vue';
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';
import 'bootstrap/js/src/tooltip';
import CookiePolicy from 'Vue/Web/Common/CookiePolicy.vue';
export default class extends _BaseController {
  HeaderControllerVue?: Vue;
  CookiePolicy ?: Vue;
  ready() {
    super.ready();

    this.HeaderControllerVue = new Vue(HeaderController);


    this.CookiePolicy = new Vue({
      el: '.footer-bar',
      name: 'CookiePolicy',
      components: {
        CookiePolicy,
      },
    });

    $('[data-toggle="tooltip"]').tooltip();

    $(window).on('load', () => {
      // bannerCarousel
      $('.banner .owl-carousel').owlCarousel({
        autoplay: true, // 自動撥放
        autoplayTimeout: 6000,
        autoplayHoverPause: true,
        loop: true, // 圖片循環
        center: false, // 是否置中
        navText: [], // 箭頭預設文字消失
        nav: false, // 前後箭頭
        dot: true,
        items: 1,
      });
    });

    // promotionBar
    $('.promotionbar .close-btn').click(() => {
      $('.promotionbar').css('display', 'none');
    });

  }
}
